import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { BriTeammateCanAccessGuard } from '@davita/bridge-utility-library/authorization';
import { BriTeammateLoginComponent } from '@davita/bridge-utility-library/login';
import { PatientDetailsComponent } from './patient-details/patient-details.component';
import { authoroziedUserGuard } from './guards/authorized-user-guard';
import { NotAuthorizedComponent } from './not-authorized/not-authorized.component';
import { LayoutComponent } from './layout/layout.component';
import { RecentSearchesComponent } from './recent-searches/recent-searches.component';
import { LoginWrapperComponent } from './login-wrapper/login-wrapper.component';


const routes: Routes = [
  {
    path:'login',
    component: LoginWrapperComponent
  },
  {
    path: 'search',
    loadChildren: () => import('./patient-search/patient-search.module').then(m => m.PatientSearchModule)
  },
  {
    path: 'patient-details',
    component: LayoutComponent,
    canActivate: [BriTeammateCanAccessGuard, authoroziedUserGuard],
    children: [
      {
        path: '',
        component: PatientDetailsComponent
      }
    ]
  },
  {
    path: 'recent',
    component: LayoutComponent,
    canActivate: [BriTeammateCanAccessGuard, authoroziedUserGuard],
    children: [
      {
        path: '',
        component: RecentSearchesComponent
      }
    ]
  },
  {
    path: 'unauthorized-user',
    component: NotAuthorizedComponent
  },
  { path: '', redirectTo: '/search', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
